class ODataHelpers
{
    escapeODataString(value: string): string
    {
        return encodeURIComponent(value
            .replace(/'/g, "''")
            .replace(/#/g, "%23")
            .replace(/\+/g, "%2B"));
    }
}

export const ODataHelper = new ODataHelpers();
